import { Icon } from '@chakra-ui/react';

const PCTabIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M28.52,10.24c-0.31,0-0.53,0-0.76,0c-6.54,0-13.07,0-19.61,0c-0.82,0-0.88-0.05-0.88-0.87
		c0-1.14-0.01-2.28,0.01-3.42C7.29,5.49,7.12,5.3,6.65,5.3C5,5.31,3.35,5.31,1.69,5.3c-0.48,0-0.63,0.21-0.63,0.66
		c0.01,6.37,0,12.73,0.01,19.1c0,1.02,0.56,1.53,1.63,1.53c3.86,0.01,7.71,0,11.57,0.01c0.38,0,0.93-0.12,0.92,0.46
		c-0.01,0.55-0.55,0.4-0.9,0.4c-3.86,0.01-7.71,0-11.57,0c-1.57,0-2.52-0.95-2.52-2.51c0-6.33,0-12.66,0-18.99
		c0-1.05,0.48-1.53,1.52-1.53c1.65,0,3.31-0.03,4.96,0.02c0.39,0.01,0.86,0.21,1.14,0.48C8.1,5.22,8.34,5.3,8.7,5.3
		c6.27-0.01,12.54-0.01,18.81,0c1.03,0,1.58,0.35,1.81,1.13c0.06,0.2,0.07,0.41,0.07,0.62c0,5.99,0,11.97,0,17.96
		c0,1.49-0.97,2.46-2.46,2.46c-3.27,0-6.54,0-9.8,0c-0.11,0-0.25,0.04-0.34-0.01c-0.16-0.1-0.41-0.27-0.39-0.37
		c0.03-0.17,0.21-0.36,0.38-0.46c0.13-0.08,0.33-0.03,0.5-0.03c3.14,0,6.27,0,9.41,0c1.38,0,1.83-0.46,1.84-1.85
		c0-4.62,0-9.24,0-13.85C28.52,10.7,28.52,10.51,28.52,10.24z M8.2,6.16c0,1.08,0,2.12,0,3.16c2.06,0,4.08,0,6.11,0
		c0-1.07,0-2.11,0-3.16C12.27,6.16,10.26,6.16,8.2,6.16z M15.27,6.17c0,1.08,0,2.11,0,3.16c2.06,0,4.08,0,6.12,0
		c0-1.07,0-2.1,0-3.16C19.35,6.17,17.34,6.17,15.27,6.17z M28.52,9.34c0-0.59,0-1.12,0-1.64c0-1.55,0-1.55-1.55-1.55
		c-1.53,0-3.06,0-4.61,0c0,1.1,0,2.15,0,3.2C24.42,9.34,26.42,9.34,28.52,9.34z"/>
			<path class="st0" d="M13.69,18.78c0.5-2.35-1.18-4.89-3.6-5.57c-0.96-0.27-1.92-0.25-2.86,0.03c-0.32,0.1-0.59,0.1-0.7-0.24
		c-0.11-0.36,0.17-0.49,0.46-0.59c3.25-1.07,6.97,1.16,7.58,4.56c0.59,3.32-1.45,6.32-4.78,7.02c-3.04,0.64-6.14-1.39-6.87-4.54
		c-0.52-2.24,0.15-4.16,1.79-5.74c0.16-0.15,0.44-0.28,0.64-0.26c0.38,0.04,0.39,0.47,0.01,0.82c-0.87,0.79-1.46,1.75-1.65,2.91
		c-0.08,0.46-0.07,0.93,0.02,1.44c0.54-0.74,1.08-1.48,1.62-2.21c0.11-0.15,0.23-0.31,0.36-0.44c0.61-0.6,1.36-0.59,1.94,0.05
		c0.39,0.43,0.75,0.9,1.15,1.38c0.27-0.35,0.5-0.67,0.76-0.97c0.68-0.79,1.44-0.79,2.12-0.01C12.34,17.19,13,17.97,13.69,18.78z
		 M11.64,22.24c-0.04-0.08-0.08-0.16-0.14-0.23c-1.48-1.78-2.96-3.55-4.43-5.34c-0.32-0.39-0.61-0.31-0.87,0.05
		c-0.7,0.96-1.41,1.93-2.08,2.91c-0.1,0.15-0.12,0.46-0.03,0.6c0.42,0.62,0.82,1.29,1.36,1.79C7.13,23.56,9.97,23.63,11.64,22.24z
		 M12.41,21.75c0.35-0.57,0.67-1.04,0.92-1.54c0.08-0.15,0.04-0.45-0.07-0.59c-0.72-0.88-1.47-1.73-2.21-2.59
		c-0.2-0.23-0.4-0.42-0.72-0.18c-0.4,0.3-0.93,1.22-0.81,1.43c0.02,0.03,0.04,0.06,0.07,0.09C10.5,19.46,11.41,20.55,12.41,21.75z"
			/>
			<path class="st0" d="M20.86,20.05c-1.39,0-2.77,0-4.16,0c-0.33,0-0.72,0.01-0.73-0.43c-0.01-0.44,0.36-0.46,0.7-0.46
		c2.79,0,5.59,0,8.38,0c0.32,0,0.67,0.02,0.67,0.43c0.01,0.45-0.36,0.46-0.7,0.46C23.63,20.05,22.25,20.05,20.86,20.05z"/>
			<path class="st0" d="M20.83,14.47c-1.4,0-2.81,0-4.21,0c-0.33,0-0.68-0.04-0.63-0.44c0.02-0.16,0.39-0.4,0.61-0.4
		c2.83-0.03,5.66-0.02,8.48-0.02c0.32,0,0.67,0.03,0.65,0.45c-0.02,0.41-0.37,0.41-0.68,0.41C23.63,14.46,22.23,14.47,20.83,14.47z"
			/>
			<path class="st0" d="M20.9,22.81c-1.42,0-2.84,0-4.27,0c-0.32,0-0.67-0.02-0.67-0.42c0-0.41,0.36-0.41,0.68-0.41
		c2.81,0,5.61,0,8.42,0c0.32,0,0.67,0,0.66,0.42c0,0.42-0.36,0.41-0.67,0.41C23.66,22.81,22.28,22.81,20.9,22.81z"/>
			<path class="st0" d="M18.21,16.4c0.53,0,1.06-0.04,1.59,0.02c0.2,0.02,0.38,0.26,0.57,0.4c-0.17,0.14-0.33,0.41-0.51,0.41
		c-1.13,0.04-2.27,0.04-3.4,0c-0.17-0.01-0.34-0.27-0.51-0.41c0.19-0.14,0.36-0.38,0.56-0.4C17.08,16.37,17.65,16.4,18.21,16.4z"/>
			<path class="st0" d="M23.68,16.4c0.51,0,1.03-0.04,1.54,0.02c0.18,0.02,0.34,0.26,0.51,0.4c-0.17,0.14-0.33,0.41-0.5,0.41
		c-1.08,0.04-2.17,0.04-3.25,0c-0.16-0.01-0.32-0.28-0.47-0.43c0.17-0.13,0.33-0.37,0.52-0.38C22.58,16.37,23.13,16.4,23.68,16.4z"
			/>
			<path class="st0" d="M3.83,8.19c-0.27,0-0.55,0.05-0.79-0.02C2.87,8.12,2.67,7.92,2.63,7.75C2.61,7.65,2.86,7.37,3,7.36
		c0.55-0.05,1.1-0.05,1.65,0c0.16,0.01,0.3,0.27,0.44,0.42C4.94,7.91,4.8,8.12,4.62,8.17C4.38,8.24,4.1,8.19,3.83,8.19z"/>
			<path class="st0" d="M10.97,8.19c-0.27,0-0.54,0.05-0.79-0.02C10.02,8.13,9.81,7.92,9.8,7.77c-0.01-0.14,0.21-0.4,0.34-0.41
		c0.56-0.05,1.14-0.06,1.7,0c0.15,0.01,0.35,0.28,0.38,0.45c0.02,0.1-0.24,0.32-0.41,0.36C11.54,8.23,11.25,8.19,10.97,8.19
		C10.97,8.19,10.97,8.19,10.97,8.19z"/>
			<path class="st0" d="M18.31,8.19c-0.25,0-0.51,0.05-0.74-0.02c-0.18-0.05-0.33-0.24-0.49-0.37c0.14-0.15,0.26-0.43,0.41-0.44
		c0.56-0.05,1.14-0.04,1.7,0.01c0.14,0.01,0.35,0.28,0.34,0.41c-0.01,0.14-0.22,0.35-0.38,0.39C18.89,8.23,18.6,8.19,18.31,8.19
		C18.31,8.19,18.31,8.19,18.31,8.19z"/>
			<path class="st0" d="M25.42,8.19c-0.27,0-0.55,0.05-0.79-0.02c-0.18-0.05-0.38-0.24-0.43-0.41c-0.03-0.1,0.22-0.39,0.36-0.4
		c0.56-0.05,1.14-0.05,1.7,0c0.14,0.01,0.38,0.29,0.36,0.39c-0.04,0.17-0.24,0.37-0.41,0.42C25.96,8.24,25.68,8.19,25.42,8.19z"/>
		</g>

	</Icon>
);

export default PCTabIcon;
